import React from 'react';
import { Link } from 'react-router-dom';
import ShuttlrBrandMark from '../common/ShuttlrBrandMark';
import { LANDING_NAV_LINKS } from './LandingNav';

const LandingFooter = () => (
  <footer className="mt-8 bg-gradient-to-r from-[#0a1628] via-slate-900 to-slate-800 text-white">
    <div className="mx-auto flex max-w-app-shell flex-col gap-8 px-6 py-10 sm:px-8 lg:flex-row lg:items-start lg:justify-between lg:px-10">
      <div>
        <div className="flex items-center gap-2.5">
          <ShuttlrBrandMark />
          <span className="text-lg font-bold">Shuttlr</span>
        </div>
        <p className="mt-2 text-sm text-white/70">Play. Track. Improve.</p>
      </div>
      <nav aria-label="Footer" className="flex flex-wrap gap-x-6 gap-y-2 text-sm text-white/80">
        {LANDING_NAV_LINKS.map((item) => (
          <a key={item.href} href={item.href} className="hover:text-white">
            {item.label}
          </a>
        ))}
        <Link to="/privacy" className="hover:text-white">Privacy</Link>
        <Link to="/login" className="hover:text-white">Log in</Link>
        <Link to="/signup" className="hover:text-white">Sign up</Link>
      </nav>
    </div>
  </footer>
);

export default LandingFooter;
